import StyleFactory, { getPropFromFeature } from '../../StyleFactory';
import frontGeometry from '../geom/frontGeometry';
export const themeSelector = (value, theme) => {
  const type = value.toLowerCase();
  const color = theme.color[type];
  return {
    fill: {
      color
    },
    stroke: {
      color,
      width: 1
    }
  };
};
const view = StyleFactory.createStyle({
  labelSelector: null,
  valueSelector: getPropFromFeature('FrontType'),
  geometry: frontGeometry({
    sizeFactor: 4
  }),
  themeSelector
});
export default ((...args) => (feature, resolution, params) => {
  const {
    time
  } = params;
  const startTime = getPropFromFeature('StartTime')(feature);
  const endTime = getPropFromFeature('EndTime')(feature);
  return time >= new Date(startTime).getTime() && time < new Date(endTime).getTime() ? view(...args)(feature, resolution, params) : null;
});